import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { isJustGiving } from '../../../../lib/environment'
import { createTeam, joinTeam } from 'supporticon/api/teams'
import { fetchPage, fetchPages } from 'supporticon/api/pages'
import { fetchSessionTeam, selectTeam } from '../../../../store/session'
import { selectButtonDefaults } from '../../../../store/site'
import withForm from 'constructicon/with-form'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Button from '../../../ui/Button'
import ButtonGroup from 'constructicon/button-group'
import Form from 'constructicon/form'
import Grid from 'constructicon/grid'
import Heading from 'constructicon/heading'
import InputField from 'constructicon/input-field'
import Modal from '../../../ui/FlatModal'
import PaginationLink from 'constructicon/pagination-link'
import SearchResult from 'constructicon/search-result'
import SearchResults from 'constructicon/search-results'
import SingleSignOnLink from 'supporticon/components/single-sign-on-link'
import Success from '../../../ui/Success'

class TeamRegistration extends Component {
  constructor (props) {
    super(props)
    this.closeModal = this.closeModal.bind(this)
    this.handleCreateTeam = this.handleCreateTeam.bind(this)
    this.renderModal = this.renderModal.bind(this)

    this.state = {
      errors: [],
      loading: false,
      modal: false,
      page: 1,
      successMessage: null,
      teams: [],
      view: 'initial'
    }
  }

  componentDidMount () {
    const { campaign, charity } = this.props

    this.setState({ loading: true })

    fetchPages({
      allPages: true,
      type: 'team',
      campaign,
      charity
    }).then((teams) => this.setState({
      loading: false,
      teams: teams.map((page) => ({
        id: page.owner_uid,
        image: page.image && page.image.medium_image_url,
        name: page.name,
        page: page.id,
        url: page.url
      }))
    }))
  }

  handleCreateTeam (event) {
    const {
      fetchSessionTeam,
      form,
      page,
      user
    } = this.props

    event.preventDefault()

    return form.submit().then(({ name }) => {
      this.setState({ loading: true, errors: [] })

      return createTeam({ name, page: page.id, token: user.token })
        .then((teamPage) => {
          this.setState({ view: 'success', loading: false, successMessage: `Your team '${teamPage.name}' has been created` })
          return fetchSessionTeam(teamPage)
        }).catch(({ data }) => (
          this.setState({ loading: false, errors: data.error.errors || [{ message: 'An error occurred' }] })
        ))
    })
  }

  handleJoinTeam (id) {
    const {
      fetchSessionTeam,
      page,
      user
    } = this.props

    this.setState({ loading: true })

    return joinTeam({ id, page: page.id, token: user.token })
      .then((team) => fetchPage(team.leader_id))
      .then((leader) => fetchPage(leader.team_page_id))
      .then((teamPage) => {
        this.setState({ view: 'success', loading: false, successMessage: `You have joined the team '${teamPage.name}'` })
        return fetchSessionTeam(teamPage)
      }).catch(({ data }) => (
        this.setState({ loading: false, errors: data.error.errors || [{ message: 'An error occurred' }] })
      ))
  }

  closeModal () {
    this.setState({
      errors: [],
      loading: false,
      modal: false,
      page: 1,
      view: 'initial'
    })
  }

  renderModal () {
    const {
      button,
      classNames,
      form,
      pageSize,
      styles,
      team,
      user
    } = this.props

    const {
      errors,
      loading,
      modal,
      page,
      successMessage,
      teams,
      view
    } = this.state

    const modalProps = {
      isOpen: modal,
      onRequestClose: this.closeModal,
      spacing: 1.5,
      styles: styles.modal
    }

    switch (view) {
      case 'create':
        return (
          <Modal contentLabel='Create team' {...modalProps}>
            <Heading>Create a team</Heading>
            <Form
              isLoading={loading}
              noValidate
              submit='Create'
              errors={errors}
              onSubmit={this.handleCreateTeam}>
              <InputField {...form.fields.name} />
            </Form>
            <a className={classNames.link} onClick={this.closeModal}>Cancel</a>
          </Modal>
        )
      case 'join':
        // Pagination
        const isLastPage = (teams.length / pageSize) < page
        const currentIndex = (page - 1) * pageSize
        const pagedTeams = teams.slice(currentIndex, currentIndex + pageSize)

        return (
          <Modal contentLabel='Join a team' {...modalProps}>
            <Heading>Join a team</Heading>
            {errors.map(({ message }) => <div className={classNames.error}>{message}</div>)}
            <SearchResults
              emptyLabel='No teams found'
              loading={loading}
              styles={styles.results}>
              {pagedTeams.map((team) => (
                <SearchResult
                  key={team.id}
                  image={team.image}
                  title={team.name}
                  cta='Join Team'
                  button={{ onClick: () => this.handleJoinTeam(team.id) }}
                />
              ))}
            </SearchResults>
            {teams.length > pageSize && (
              <Grid justify={'center'} styles={styles.pagination}>
                <PaginationLink onClick={() => this.setState({ page: page - 1 })} direction='prev' disabled={page <= 1} />
                <PaginationLink onClick={() => this.setState({ page: page + 1 })} direction='next' disabled={isLastPage} />
              </Grid>
            )}
            <a className={classNames.link} onClick={this.closeModal}>Cancel</a>
          </Modal>
        )
      case 'success':
        return team && (
          <Modal contentLabel='Success!' {...modalProps}>
            <Success title={successMessage}>
              <SingleSignOnLink
                token={user.token}
                url={team.url}
                label='Visit your team page'
                {...button}
              />
            </Success>
            <a className={classNames.link} onClick={this.closeModal}>Close</a>
          </Modal>
        )
      default:
        return null
    }
  }

  render () {
    const {
      button,
      classNames,
      team,
      user
    } = this.props

    if (isJustGiving()) {
      return null
    }

    return (
      <div className={classNames.root}>
        {team ? (
          <SingleSignOnLink
            token={user.token}
            url={team.url}
            label={`Visit your team (${team.name})`}
            {...button}
          />
        ) : (
          <div>
            <Heading tag='h3' size={0}>Fundraising with others? Find a team or create your own</Heading>
            <ButtonGroup styles={styles.buttons}>
              <Button tag='a' onClick={() => this.setState({ modal: true, view: 'create' })}>Create team</Button>
              <Button tag='a' onClick={() => this.setState({ modal: true, view: 'join' })}>Join a team</Button>
            </ButtonGroup>
          </div>
        )}
        {this.renderModal()}
      </div>
    )
  }
}

TeamRegistration.defaultProps = {
  pageSize: 5
}

const mapState = (store) => ({
  button: selectButtonDefaults(store),
  team: selectTeam(store)
})

const mapDispatch = { fetchSessionTeam }

const form = () => ({
  fields: {
    name: {
      label: 'Team name',
      placeholder: 'Team name (Optional)'
    }
  }
})

export default compose(
  connect(mapState, mapDispatch),
  withForm(form),
  withStyles(styles)
)(TeamRegistration)



// WEBPACK FOOTER //
// ./components/slices/Registration/TeamRegistration/index.js